
export function buildOptions(list, valKey, labelKey) {
  const src = Array.isArray(list) ? list : [];
  if (src.length === 0) return [];
  const sample = src[0];
  let vk = valKey, lk = labelKey;
  if (!(valKey in sample)) {
    const keys = Object.keys(sample);
    vk = keys.find(k => /code/i.test(k)) || keys[0];
    lk = keys.find(k => /name/i.test(k)) || keys.find(k => /desc/i.test(k)) || keys[1] || keys[0];
  }
  return src.map(i => ({ value: String(i[vk] ?? ''), label: String(i[lk] ?? i[vk] ?? '') })).filter(o => o.value);
}
